export default __webpack_public_path__ + "static/media/bag.b7df1abd.png";